/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MenuCategory
 */
export interface MenuCategory {
    /**
     * 
     * @type {number}
     * @memberof MenuCategory
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof MenuCategory
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MenuCategory
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof MenuCategory
     */
    index: number;
}

/**
 * Check if a given object implements the MenuCategory interface.
 */
export function instanceOfMenuCategory(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "index" in value;

    return isInstance;
}

export function MenuCategoryFromJSON(json: any): MenuCategory {
    return MenuCategoryFromJSONTyped(json, false);
}

export function MenuCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'index': json['index'],
    };
}

export function MenuCategoryToJSON(value?: MenuCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'index': value.index,
    };
}

